import React from 'react';
import SidebarSectionContainer from "../Sections/SidebarSectionContainer";
import {useTranslation} from "@Translation/hooks/useTranslation";
import BlogPosts from "./BlogPosts";
import LatestBlogType from "@Sidebar/types/LatestBlog.type";
import IconBlog from "@Icons/IconBlog";

interface BlogPostsContainerProps {
    latestBlogPosts: LatestBlogType[]
}

function BlogPostsContainer({latestBlogPosts}: BlogPostsContainerProps) {
    const latestBlogPostsTitle = useTranslation("search_results.latest_blog_posts")

    return (
        <SidebarSectionContainer
            contentArray={latestBlogPosts}
            title={latestBlogPostsTitle}
            icon={<IconBlog width={32} height={32}/>}
        >
            <BlogPosts blogPosts={latestBlogPosts}/>
        </SidebarSectionContainer>
    );
}

export default BlogPostsContainer;